import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { InspectionCase } from '@authority-labs/api-interfaces';

@Component({
  selector: 'authority-labs-check-case',
  templateUrl: './check-basic-case.component.html',
  styleUrls: ['./check-basic-case.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckBasicCaseComponent {
  @Input() inspection: InspectionCase;
  @Input() readonly: boolean;
  @Input() printPreview: boolean;
  @Input() allwaysApplicable = false;
  @Input() multiNote = false;
  @Input() hideConclusion = false;
  @Input() hideNotes = false;
  @Input() fieldSection: string;
  @Output() dataChange: EventEmitter<void> = new EventEmitter();

  showNotes = false;

  onChange(): void {
    this.dataChange.emit();
  }
}
